<template>
    <div class="f" :class="{'fd-c': !isFirstFloor}">
        <div v-for="item in data" :key="item.code">
            <div v-if="item.child">
                <el-popover
                    placement="right"
                    trigger="hover" >
                    <el-button slot="reference" style="margin-right: 10px;margin-bottom: 10px" @click="itemClick(item)" :type="getColor(item.color)">{{ `${item.name}(${item.child ? 'list': 'text'})` }}</el-button>
                    <dynamicLabel-button :data="item.child" @itemClick="itemClick"></dynamicLabel-button>
                </el-popover>
            </div>
            <el-button v-else @click="itemClick(item)" style="margin-right: 10px;margin-bottom: 10px">{{`${item.name}(text)`}}</el-button>
        </div>
    </div>
</template>

<script>
// import { dynamicLabelTree } from './data'
export default {
    name: 'dynamicLabel-button',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        isFirstFloor: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        btnColor() {
            const colorMap = {
                primary: '#409eff',
                success: '#67c23a',
                info: '#909399',
                warning: '#e6a23c',
                danger: '#f56c6c'
            }
            return colorMap
        }
    },
    methods: {
        itemClick(item) {
            this.$emit('itemClick', item)
        },
        getColor(type) {
            const colorMap = {
                primary: '#409eff',
                success: '#67c23a',
                info: '#909399',
                warning: '#e6a23c',
                danger: '#f56c6c',
                '#f56c6c': 'danger',
                '#e6a23c': 'warning',
                '#909399': 'info',
                '#67c23a': 'success',
                '#409eff': 'primary'
            }
            return colorMap[type]
        }
    },
}
</script>